import React from 'react';
import MemberDetailsCard from './MemberDetailsCard';

const COLUMNS = [
  { field: 'Name', header: 'First name' },
  { field: 'Surname', header: 'Last name' },
  { field: 'Gender', header: 'Gender' },
  { field: 'ID_num', header: 'ID number' },
  { field: 'Date_of_birth', header: 'Date Of Birth' },
  { field: 'Age', header: 'Age' },
  { field: 'PolicyMaturityDate', header: 'Maturity' },
];

const ViewChildBeneficiaries = ({ activeUserData }) => (
  <MemberDetailsCard
    title="CHILD BENEFICIARY DETAILS"
    sections={[{ value: activeUserData.memberChild, columns: COLUMNS, emptyMessage: 'No child beneficiaries found' }]}
  />
);

export default ViewChildBeneficiaries;
